import { useState, useEffect } from 'react';
import {
	experiencieBagdetFeedView,
	experiencieBagdetName,
} from '../../../types/experiencieBagdet';

import ModalTolltip from '../../Modal/Tooltip';

interface experienceBadgetProps {
	experienceBadget: any;
}

export default function TooltipTournamentFeed({
	experienceBadget,
}: experienceBadgetProps) {
	const [isOpen, setIsOpen] = useState(false);

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = () => setIsOpen(false);

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		if (!isOpen) return;
		const timer = setTimeout(() => {
			setIsOpen(false);
		}, 5000);

		return () => {
			clearTimeout(timer);
		};
	}, [isOpen]);

	return (
		<div className="relative inline-block">
			<button
				onClick={(e: any) => {
					e.stopPropagation();
					handleClick();
				}}
				className="flex justify-center items-center"
			>
				<div className="text-[#adadad] text-[12px] font-bahnschrift uppercase tracking-[3.20px]">
					{experiencieBagdetName(experienceBadget)}
				</div>
				{experiencieBagdetFeedView(experienceBadget)}
			</button>

			<ModalTolltip
				id={'modalTooltipExp'}
				open={isOpen}
				onClose={handleClick}
				infoIcon={'warning'}
			>
				<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
					{experienceBadget === 0 ? 'Novato' : 'Profissional'}
				</h2>
				<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
					{experienceBadget === 0
						? 'Para garantir que todos tenham uma competição justa, esse torneio é somente para Novatos.'
						: 'Para garantir que todos tenham uma competição justa, esse torneio é somente para Profissionais.'}
				</p>
			</ModalTolltip>
		</div>
	);
}
